import { breakpoints } from '../utils/breakpoints';

const handleVideoPoster = () => {
  const selectors = {
    section: '.js-video-section',
    video: '.js-video-elem',
    poster: '.js-video-poster',
  };

  const state = {
    hidden: 'is-hidden',
  };

  const sections = [...document.querySelectorAll(selectors.section)];
  if (sections.length === 0) return;

  sections.forEach((section) => {
    const videoEl = section.querySelector(selectors.video);
    const videoPoster = section.querySelector(selectors.poster);

    const clickFunction = () => {
      const sources = videoEl.querySelectorAll('source');

      sources.forEach((source) => {
        if (window.innerWidth < breakpoints.mobile) {
          source.setAttribute('src', source.dataset.mobileSrc);
        } else {
          source.setAttribute('src', source.dataset.desktopSrc);
        }

        videoEl.load();

        videoEl.oncanplay = () => {
          videoPoster.classList.add(state.hidden);
          videoEl.play();
        };
      });
    };

    section.addEventListener('click', clickFunction, { once: true });
  });
};

export default handleVideoPoster;
